import { IconTypes } from '@eika/icon';

export default {
    car: IconTypes.BIL_36,
    carElectric: IconTypes.BIL_36,
    carNoInsurance: IconTypes.BIL_36,
    mc: IconTypes.MOTORSYKKEL_36,
    atv: IconTypes.ATV_36,
    snowmobile: IconTypes.SNOSCOOTER_36,
    campingCar: IconTypes.BOBIL_36,
    campingCaravan: IconTypes.CAMPING_36,
    boat: IconTypes.BAT_36,
    creditLoan: IconTypes.LAN_36,
    creditCard: IconTypes.BANKKORT_36,
    unknown: IconTypes.UTROPSTEGN_36,
};
